import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { del } from 'utils/http'

export const useAgencyAccountUnlink = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const unlinkAccount = async (subAccountId: number) =>
    del(`/management/customers/${customerId}/master/accounts/${subAccountId}`)

  return useMutation({
    mutationFn: unlinkAccount,
    onSuccess: async () => {
      addNotification('Account successfully removed')

      await queryClient.invalidateQueries({ queryKey: ['agencies', customerId] })
    },
  })
}
